import React, {PropTypes} from 'react';
import EntryListContainer from './EntryListContainer.jsx';
import VirtualEntryListContainer from './VirtualEntryListContainer.jsx';
import PayBalanceContainer from './PayBalanceContainer.jsx';
import RosterConfirmationDialogContainer from './RosterConfirmationDialogContainer.jsx';
import SquadChangeModalContainer from './SquadChangeModalContainer.jsx';
import EventChangeModalContainer from './EventChangeModalContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';

const Manage = ({
  entriesQty,
  allRostersComplete,
  virtualEntriesQty,
  rosterMessage,
  loadingEntries,
  loadingVirtualEntries
}) => (
  <div>
    <DisplayIf condition={allRostersComplete}>
      <div className="row">
        <div className="col-sm-12 animated fadeIn">
            <div className="alert alert-success text-center">
              <p>{`You're all done!`}</p>
            </div>
        </div>
      </div>
    </DisplayIf>

    <DisplayIf condition={!!rosterMessage}>
      <div className="row">
        <div className="col-sm-12 animated fadeIn">
            <div className="alert alert-info text-center">
              { rosterMessage ? <p>{rosterMessage}</p> : null }
            </div>
        </div>
      </div>
    </DisplayIf>

    <div className="animated fadeIn">
      <PayBalanceContainer />
      {
        loadingEntries
        ? <div className="alert alert-info">{'Loading entries'}</div>
        : entriesQty
          ? <EntryListContainer />
          : <div className="alert alert-info">{'No entries to display'}</div>
      }
      {
        loadingVirtualEntries
        ? <div className="alert alert-info">{'Loading virtual entries'}</div>
        : virtualEntriesQty
          ? <VirtualEntryListContainer />
          : null
      }
    </div>

    <RosterConfirmationDialogContainer />
    <SquadChangeModalContainer />
    <EventChangeModalContainer />
  </div>
);

Manage.propTypes = {
  entriesQty: PropTypes.number,
  allRostersComplete: PropTypes.bool,
  virtualEntriesQty: PropTypes.number,
  rosterMessage: PropTypes.string,
  loadingEntries: PropTypes.bool,
  loadingVirtualEntries: PropTypes.bool
};

Manage.defaultProps = {
  entriesQty: 0,
  allRostersComplete: false,
  virtualEntriesQty: 0,
  rosterMessage: '',
  loadingEntries: true,
  loadingVirtualEntries: true
};

export default Manage;



// WEBPACK FOOTER //
// ./src/features/registration/manage/Manage.jsx